import { useMemo } from "react";

import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const useAppcues = () => {
  const { data: user } = useUser();
  const { isAuthenticatedUser, isImpersonated, ...userProperties } = useMemo(
    () =>
      getUserProperties(user, {
        shouldUseNewUserApi: false,
      }),
    [user],
  );

  if (typeof window === "undefined") {
    return;
  }

  if (!window.Appcues) {
    console.warn("Appcues has not been initialized.");
    return;
  }

  const Appcues = window.Appcues;

  // Only runs Appcues experiments when we have a Signed In user.
  // Appcues bills by monthly active users (MAUs), so we've currently
  // decided to activate Appcues for authenticated users only, thus limiting our MAUs.
  // Also, do not show appcues while impersonating a user. The user should see these not our staff!
  if (!isAuthenticatedUser || isImpersonated) {
    console.warn(
      "Appcues features are disabled for impersonated and unauthenticated users.",
    );
    window.Appcues.reset();
    return;
  }

  return {
    track: Appcues.track,
    identify: () => Appcues.identify(user.unique_id, userProperties),
    page: Appcues.page,
  };
};

export default useAppcues;
